import React from 'react';
import { t } from 'i18next';
import { metricNamingMap } from '../../EngineVersionUtils';

interface MetricTooltipContentProps {
  metrics: { metricType: string; value: string }[];
}

const MetricTooltipContent = ({ metrics }: MetricTooltipContentProps) => {
  return (
    <div>
      <div>
        <strong>{t('compressorMetrics')}</strong>
      </div>
      {metrics &&
        metrics.map(metric => (
          <div key={metric.metricType}>
            {metricNamingMap[metric.metricType]}: {metric.value}
          </div>
        ))}
    </div>
  );
};

export default MetricTooltipContent;
